import { injectReducer } from 'store/reducers.js'
import { authRoute } from 'helpers/routes'

export const CategoriesRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'categories',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/CategoriesContainer').default

      const actions = require('./modules/categories').actions
      const reducer = require('./modules/categories').default

      injectReducer(store, { key: 'categories', reducer })

      store.dispatch(actions.get())

      cb(null, Container)
    }, 'categories')
  }
})

export const NewCategoryRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'categories/new',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/NewCategoryContainer').default

      const reducer = require('./modules/category').default

      injectReducer(store, { key: 'category', reducer })

      cb(null, Container)
    }, 'categories')
  }
})

export const EditCategoryRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'categories/:id/edit',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/EditCategoryContainer').default

      const actions = require('./modules/category').actions
      const reducer = require('./modules/category').default

      injectReducer(store, { key: 'category', reducer })

      store.dispatch(actions.get(nextState.params.id))

      cb(null, Container)
    }, 'categories')
  }
})

export default function (store) {
  return [
    NewCategoryRoute(store),
    EditCategoryRoute(store),
    CategoriesRoute(store)
  ]
}



// WEBPACK FOOTER //
// ./src/routes/Categories/index.js